import PaginationComponent from 'components/pagination';
import Text from 'components/text';
import { dateTimeFormat, onKeyPress } from 'helpers/utils';
import moment from 'moment';
import { TipoProfiloSede, userInfoSelector } from 'pages/admin/_redux/selectors';
import * as React from 'react';
import { useEffect } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { postRicercaProcessi, resetForm, setDataFineAction, setDataInizioAction, setModalitaCertificazioneAction, setNdgCertificazioneAction, setNominativoCertificazioneAction, setPaginaSelezionataAction, setProcessoAction, setStatoCertificazioneAction, setTipoCerficazioneAction } from './_redux/actions';
import { elencoCertificazioniSelector, formRicercaClienteSelector, isFirstPageSelector, isLastPageSelector, numeroTotalePagineSelector, riepilogoPaginazioneSelector } from './_redux/selectors';


interface StateLocation {
  dataInizio: Date
  dataFine: Date
  statoCertificazione: number
}

export const elencoStatiCertificazione = [
  { valore: 1, descrizione: "Inserita" },
  { valore: 2, descrizione: "Invalidata" },
  { valore: 3, descrizione: "Scaduta" },
  { valore: 4, descrizione: "Inviata" },
  { valore: 6, descrizione: "Inviata email informativa" },
  { valore: 5, descrizione: "Certificata" },
];

export const elencoModalitaCertificazione = [
  { valore: 1, descrizione: "Sincrona" },
  { valore: 2, descrizione: "Asincrona" }
];

export const elencoProcesso = [
  { valore: 1, descrizione: "Processo AS-IS (FEA)" },
  { valore: 2, descrizione: "Processo mail ANAGRAFE" },
  { valore: 3, descrizione: "Processo mail HB" },
  { valore: 4, descrizione: "Processso annullato per dati incompleti" }
];

export const elencoTipoCertificazione = [
  { valore: 1, descrizione: "On boarding" },
  { valore: 2, descrizione: "Massiva" }
];

const RicercaClienti: React.VFC = () => {

  const dispatch = useAppDispatch();
  const history = useHistory();

  const location = useLocation<StateLocation>();

  const toRef = React.useRef<DayPickerInput>();

  const {
    modalitaCertificazione,
    processo,
    statoCertificazione,
    paginaSelezionata,
    ndg,
    nominativo,
    dataInizio,
    dataFine,
    tipoCertificazione
  } = useAppSelector(formRicercaClienteSelector);
  const elencoCertificazioni = useAppSelector(elencoCertificazioniSelector);
  const numeroTotalePagine = useAppSelector(numeroTotalePagineSelector);
  const isLastPage = useAppSelector(isLastPageSelector);
  const isFirstPage = useAppSelector(isFirstPageSelector);
  const riepilogoPaginazione = useAppSelector(riepilogoPaginazioneSelector);
  const userInfo = useAppSelector(userInfoSelector);

  /* calendar */
  function showFromMonth() {
    if (!dataInizio) {
      return;
    }
    if (dataFine && moment(dataFine).diff(moment(dataInizio), 'months') < 2) {
      toRef.current?.getDayPicker().showMonth(dataInizio);
    }
  }

  const cercaProcessi = () => {
    setPaginaSelezionata(1);
    // dispatch(postRicercaProcessi());
  };

  function handleToChange(date: Date) {
    dispatch(setDataFineAction(date));
    showFromMonth();
  }

  function handleFromChange(date: Date) {
    dispatch(setDataInizioAction(date));
  }

  const setPaginaSelezionata = (pagina: number) => {
    dispatch(setPaginaSelezionataAction(pagina));
    dispatch(postRicercaProcessi());
  }

  useEffect(() => {
    if (history.action !== 'POP') {
      dispatch(resetForm());
      if (location.state) {
        dispatch(setDataInizioAction(location.state.dataInizio))
        dispatch(setDataFineAction(location.state.dataFine))
        dispatch(setStatoCertificazioneAction(location.state.statoCertificazione));
      }
    }
    dispatch(postRicercaProcessi());
  }, [history.action, dispatch]);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' && ndg) {
      cercaProcessi();
    }

    onKeyPress(event, event.currentTarget.id == 'nominativo');
  };

  function onNdgChange(evt: any) {
    if (evt.target.value.length <= 12) {
      dispatch(setNdgCertificazioneAction(evt.target.value));
    }
  }

  function onNominativoChange(evt: any) {
    dispatch(setNominativoCertificazioneAction(evt.target.value));
  }

  const modifiers = { start: dataInizio, end: dataFine };
  return (
    <div>
      <div>
        <Row className="mb-3">
          <Col>
            <Text title={"Ricerca il NDG del cliente e verifica la certificazione dei contatti" + (userInfo && userInfo?.tipoProfilo !== TipoProfiloSede ? ". Dati filtrati per filiale prevalente: " + userInfo.codiceFiliale : "")} type='sottotitolo' />
          </Col>
        </Row>

        <Row className="InputFromTo mb-3">
          <Col>
            <Text title="NDG"></Text>
            <Form.Control type="text" onKeyPress={handleKeyPress} onChange={onNdgChange} value={ndg} placeholder="Cerca NDG" />
          </Col>
          <Col>
            <Text title="Nominativo"></Text>
            <Form.Control id="nominativo" type="text" onKeyPress={handleKeyPress} onChange={onNominativoChange} value={nominativo} placeholder="Cerca nominativo" />
          </Col>
          <Col>
            <Text title="Data inserimento dal"></Text>
            <DayPickerInput
              value={dataInizio}
              placeholder="From"
              format="LL"
              formatDate={MomentLocaleUtils.formatDate}
              parseDate={MomentLocaleUtils.parseDate}
              inputProps={{ className: 'form-control' }}
              dayPickerProps={{
                locale: 'it',
                localeUtils: MomentLocaleUtils,
                selectedDays: [dataInizio, { from: dataInizio, to: dataFine }],
                disabledDays: { after: dataFine },
                toMonth: dataFine,
                modifiers,
                numberOfMonths: 2,
                onDayClick: () => toRef.current?.getInput().focus(),
              }}
              onDayChange={handleFromChange}
            />
          </Col>
          <Col>
            <span className="InputFromTo-to">
              <Text title="Data inserimento al"></Text>
              <DayPickerInput
                ref={(ref: any) => toRef.current = ref}
                value={dataFine}
                placeholder="To"
                format="LL"
                formatDate={MomentLocaleUtils.formatDate}
                parseDate={MomentLocaleUtils.parseDate}
                inputProps={{ className: 'form-control' }}
                dayPickerProps={{
                  locale: 'it',
                  localeUtils: MomentLocaleUtils,
                  selectedDays: [dataInizio, { from: dataInizio, to: dataFine }],
                  disabledDays: { before: dataInizio },
                  modifiers,
                  month: dataInizio,
                  fromMonth: dataInizio,
                  numberOfMonths: 2,
                }}
                onDayChange={handleToChange}
              />
            </span>
          </Col>
        </Row>
        <Row className="InputFromTo mb-3">
          <Col>
            <Text title="Seleziona stato"></Text>
            <Form.Control as="select" value={statoCertificazione} onChange={(e) => dispatch(setStatoCertificazioneAction(parseInt(e.target.value)))}>
              <option>Tutti</option>
              {elencoStatiCertificazione.map((x, index) =>
                <option key={'statoCertificazione_' + index} value={x.valore}>{x.descrizione}</option>
              )}
            </Form.Control>
          </Col>
          <Col>
            <Text title="Seleziona modalità"></Text>
            <Form.Control as="select" value={modalitaCertificazione} onChange={(e) => dispatch(setModalitaCertificazioneAction(parseInt(e.target.value)))}>
              <option>Tutti</option>
              {elencoModalitaCertificazione.map((x, index) =>
                <option key={'modalitaCertificazione_' + index} value={x.valore}>{x.descrizione}</option>
              )}
            </Form.Control>
          </Col>
          <Col>
            <Text title="Seleziona processo"></Text>
            <Form.Control as="select" value={processo} onChange={(e) => dispatch(setProcessoAction(parseInt(e.target.value)))}>
              <option>Tutti</option>
              {elencoProcesso.map((x, index) =>
                <option key={'processo_' + index} value={x.valore}>{x.descrizione}</option>
              )}
            </Form.Control>
          </Col>
          <Col>
            <Text title="Seleziona tipo certificazione"></Text>
            <Form.Control as="select" value={tipoCertificazione} onChange={(e) => dispatch(setTipoCerficazioneAction(parseInt(e.target.value)))}>
              <option>Tutti</option>
              {elencoTipoCertificazione.map((x, index) =>
                <option key={'tipoCertificazione_' + index} value={x.valore}>{x.descrizione}</option>
              )}
            </Form.Control>
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col className="text-center">
            <Button onClick={cercaProcessi} className="button pl-3 pr-3">Cerca <i className="fas fa-search iconRight ml-2"></i></Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table className="small" hover striped bordered responsive size="sm">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Ndg</th>
                  <th>Nominativo</th>
                  <th>Filiale</th>
                  <th>Modalità certificazione</th>
                  <th>Stato certificazione</th>
                  <th>Processo</th>
                  <th>Tipo certificazione</th>
                  <th>Data inserimento</th>
                  <th>Data ultima modifica</th>
                  <th>Data certificazione</th>
                </tr>
              </thead>
              <tbody>
                {elencoCertificazioni.map((certificazione, index) => (
                  <tr key={index}>
                    <td><Link to={'/admin/ricerca/' + certificazione.ndg + '/' + certificazione.id}>{certificazione.id}</Link></td>
                    <td><Link to={'/admin/ricerca/' + certificazione.ndg} >{certificazione.ndg}</Link></td>
                    <td>{certificazione.nominativo}</td>
                    <td>{certificazione.filialeNdg}</td>
                    <td>{certificazione.modalitaCertificazioneDesc}</td>
                    <td>{certificazione?.statoCertificazioneDesc}</td>
                    <td>{certificazione?.workFlowCertificazioneNome}</td>
                    <td>{(certificazione?.isCertificazioneFromLotto ?? false) ? "Massiva" : "On boarding"}</td>
                    <td>{dateTimeFormat(certificazione.dataInserimento)}</td>
                    <td><label className="mb-0">{dateTimeFormat(certificazione.dataUltimaModifica)}</label></td>
                    <td><label className="mb-0">{dateTimeFormat(certificazione.dataCertificazione)}</label></td>
                  </tr>
                ))}
                {elencoCertificazioni.length === 0 && (
                  <tr key={-1}>
                    <td colSpan={11} className="text-center"><Text title="Nessun risultato presente" /></td>
                  </tr>
                )}

              </tbody>
            </Table>
          </Col>
        </Row>

        <Row>
          <Col>{riepilogoPaginazione}</Col>
        </Row>
        <Row>
          <Col>
            <PaginationComponent
              numeroTotalePagine={numeroTotalePagine}
              paginaSelezionata={paginaSelezionata}
              isFirstPage={isFirstPage}
              isLastPage={isLastPage}
              setPaginaSelezionata={setPaginaSelezionata}
              elencoRisultati={elencoCertificazioni}
            />
          </Col>
        </Row>

      </div>
    </div>
  );
}

export default RicercaClienti;
